import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";

// Explains, in plain words, why processed payroll hours may not be reaching Xero.
export function XeroPayrollIssuesBanner({ refreshKey }) {
  const [issues, setIssues] = useState([]);
  useEffect(() => {
    api.get("/xero/payroll/transfer-status", { __flSkipReadCache: true })
      .then((r) => setIssues(r.data.issues || [])).catch(() => setIssues([]));
  }, [refreshKey]);
  if (!issues.length) return null;
  return (
    <div role="alert" className="rounded-lg border border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-100 p-3 mb-3" data-testid="xero-payroll-issues-banner">
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-sm">Payroll hours may not be reaching Xero</p>
          <ul className="mt-1 space-y-0.5 text-sm">
            {issues.map((i) => <li key={i.code} data-testid={`xero-payroll-issue-${i.code}`}>• {i.message}</li>)}
          </ul>
        </div>
        <Link to="/app/integrations/xero" className="shrink-0 h-8 px-3 rounded-md bg-amber-600 hover:bg-amber-700 text-white text-xs font-semibold inline-flex items-center" data-testid="xero-payroll-issues-fix">Fix in Xero settings</Link>
      </div>
    </div>
  );
}

export function XeroTransferDetails({ transfer }) {
  const result = transfer?.result || {};
  const blocked = (result.skipped || []).filter((s) => s.blocks_export !== false);
  const leaveOnly = (result.skipped || []).filter((s) => s.blocks_export === false);
  const nonWork = result.non_work_entries || [];
  if (!blocked.length && !nonWork.length && !leaveOnly.length) return null;
  return (
    <div className="mt-1.5 space-y-1 text-xs" data-testid="xero-transfer-details">
      {blocked.length > 0 && (
        <div className="text-amber-800 dark:text-amber-300">
          <p className="font-semibold">Not sent to Xero:</p>
          {blocked.map((s) => <p key={s.user_id}>• {s.name || "Worker"}: {s.reason}</p>)}
        </div>
      )}
      {nonWork.length > 0 && (
        <div className="text-zinc-600 dark:text-zinc-400">
          <p className="font-semibold">Enter these in Xero yourself (leave and public holidays aren't sent):</p>
          {nonWork.map((e, i) => <p key={i}>• {e.name || "Worker"}, {e.date}: {String(e.entry_type).replace(/_/g, " ")}{e.hours ? ` (${e.hours}h)` : ""}</p>)}
        </div>
      )}
    </div>
  );
}
